import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { DocumentModel } from "@insite/client-framework/Types/ApiModels";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconProps } from "@insite/mobius/Icon";
import File from "@insite/mobius/Icons/File";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    productDocuments: DocumentModel[];
    extendedStyles?: ProductListDocumentsStyles;
}

type Props = OwnProps;

export interface ProductListDocumentsStyles {
    wrapper?: InjectableCss;
    documentGridItem?: GridItemProps;
    documentLink?: LinkPresentationProps;
    documentIcon?: IconProps;
    documentNameText?: TypographyPresentationProps;
}

export const documentsStyles: ProductListDocumentsStyles = {
    wrapper: {
        css: css`
            margin: 5px 0 0;
        `,
    },
    documentGridItem: {
        width: 12,
    },
    documentIcon: {
        src: File,
        color: "text.link",
        css: css`
            margin-right: 10px;
        `,
    },
    documentNameText: {
        css: css`
            vertical-align: super;
        `,
    },
};

const ProductListDocuments = ({ productDocuments, extendedStyles }: Props) => {
    if (!productDocuments) {
        return null;
    }

    const [styles] = React.useState(() => mergeToNew(documentsStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.wrapper}>
            {productDocuments.map((document: DocumentModel) => (
                <GridItem key={document.id.toString()} {...styles.documentGridItem}>
                    <Link href={document.filePath} target="_new" {...styles.documentLink}>
                        <IconMemo {...styles.documentIcon} />
                        <Typography {...styles.documentNameText}>{document.name}</Typography>
                    </Link>
                </GridItem>
            ))}
        </StyledWrapper>
    );
};

export default ProductListDocuments;
